module.exports = __webpack_public_path__ + "img/mern.ac0686a4.png";